import { render } from "./MilestoneChart.vue?vue&type=template&id=2d67a5c0&scoped=true"
import script from "./MilestoneChart.vue?vue&type=script&lang=js"
export * from "./MilestoneChart.vue?vue&type=script&lang=js"

import "./MilestoneChart.vue?vue&type=style&index=0&id=2d67a5c0&lang=scss&scoped=true"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d67a5c0"]])

export default __exports__